<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入姓名/身份证号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="注册方式">
              <a-select v-model="where.keyword.registerType" placeholder="请选择" allowClear>
                <a-select-option value>个人注册</a-select-option>
                <a-select-option value="0">批量导入</a-select-option>
                <a-select-option value="1">系统注册</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="注册日期">
              <a-date-picker @change="onTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="截止日期">
              <a-date-picker @change="onTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="所在地区">
              <a-input placeholder="请输入" v-model="where.keyword.address" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="所属单位">
              <a-input placeholder="请输入" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
        <a-button type="primary" @click="searchList">搜索</a-button>-->
        <!-- <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button> -->
        <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{ expand?"闭合":"高级搜索" }}
              <a-icon :type="expand ? 'up' : 'down'"/>
        </a>-->
        <!-- </a-col>
        </a-row>-->
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn
        name="添加"
        class="pxkeji_basic_btn"
        @click="showInfo(0,1)"
        type="primary"
      />-->
      <pxkeji-btn name="下载模版" class="pxkeji_basic_btn" @click="uploadTemplate" type="primary" />
      <pxkeji-btn name="导出" @click="uploadExcel" class="pxkeji_basic_btn" />
      <pxkeji-btn
        name="批量启用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-upload
        name="file"
        :action="$api.excel.dataImport"
        accept=".xls"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button>
          <a-icon type="upload" />导入
        </a-button>
      </a-upload>

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="count" slot-scope="count">
          <span v-if="count==-1">不限</span>
          <span v-else>{{count}}</span>
        </span>
        <span slot="state" slot-scope="state">
          <a-tag v-if="state==0" color="green">正常</a-tag>
          <a-tag v-else color="red">离职</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="详情"
            :roles="[]"
            @click="showInfo(action.id,2)"
            size="small"
            type="primary"
          />
          <!-- <a-divider type="vertical" />
          <pxkeji-btn
                  name="禁用"
                  @click="handleProhibit(action.userId,0)"
                  size="small"
                  type="dashed"
                  
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  @click="handleProhibit(action.userId,1)"
                  size="small"
                  type="dashed"
              
                  v-else
          />-->
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./enrollInfo.vue"; //新增编辑

const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "编号"
  // },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "姓名"
  },
  {
    dataIndex: "gender",
    key: "gender",
    align: "center",
    title: "性别"
  },
 /* {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },*/
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号"
  },
  // {
  //   dataIndex: "school",
  //   key: "school",
  //   align: "center",
  //   title: "学校选择"
  // },
  // {
  //   dataIndex: "specialty",
  //   key: "specialty",
  //   align: "center",
  //   title: "专业选择"
  // },
  {
    dataIndex: "education",
    key: "education",
    align: "center",
    title: "所报层次"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "报名时间"
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];
var excelLoading = "";
export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        school: "",
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          registerType: "",
          startTime: "",
          endTime: "",
          address: "",
          company: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info: Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.enrollment
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.telephone,
          this.where.keyword.specialty,
          this.where.keyword.education,
          this.where.keyword.leanSpecialty,
          this.where.keyword.idCard,
          this.where.keyword.startTime,
          this.where.keyword.endTime
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            // res.data.records.forEach(function(value,index,arr){
            //     res.data.records[index].school = JSON.parse(res.data.records[index].school);
            //     // console.log(res.data.records[index].school.itemName);
            //     this.list.school = res.data.records[index].school.itemName;
            // })
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "详情";
      }
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.type = type;
      console.log(id);
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.operation.coupon
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**发券 */
    giveCoupon(id) {
      this.issuing.visible = true;
      this.issuing.id = id;
    },
    /**明细 */
    voidCoupon(id) {
      this.voids.visible = true;
      this.voids.id = id;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    },
    uploadTemplate() {
      window.location.href = this.$api.excel.uploadEnrollmentTemplate();
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      console.log("file", file.type);
      console.log("file1", file);
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleChange(info) {
      //console.log("handleChange", info);
      if (info.file.status == "uploading") {
        if (excelLoading == "")
          excelLoading = this.$message.loading("上传中", 0);
      }
      if (info.file.status == "done") {
        excelLoading();
        excelLoading = "";
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          this.$message.success(info.file.response.errorMsg);
        } else {
          this.$message.error(info.file.response.errorMsg);
        }
      }
    },
    //导出
    uploadExcel() {
      window.location.href = this.$api.enrollment.exportEnrollment(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      );
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

